// extracted by mini-css-extract-plugin
export default {"Wrapper":"CongratsComparison_Wrapper__zY7ww"};